import React from 'react';
import classNames from "classnames";
import { ButtonGroupProps } from "./PropsType";

export default function ButtonGroup(props: ButtonGroupProps) {
  const {
    dir = "horizontal",
    children,
    className,
    prefixCls = "bm-Button-group",
  } = props;
  const styleClass = classNames(prefixCls, `${prefixCls}-${dir}`, className);
  return <div className={styleClass}>{children}</div>;
}
